module.exports = new __parcel__URL__("sgt-peppers-lonely-hearts-club-band.57eedfd6.jpg").toString();